<template>
	<b-card>
		<div slot="header">
			{{ $t('sidebar.warehouse-management.inventory') }}
			<div class="card-header-actions">
				<b-link v-if="$can('start', 'inventory partial')" class="card-header-action text-dark"
						@click="toCreate('create', 0)">
					<i class="fa fa-plus-circle mt-1" style="font-size: 18px"/>
				</b-link>
			</div>
		</div>
		<b-table
			:items="items.items"
			:fields="fields"
			:per-page="0"
			responsive
			show-empty
			bordered
			striped
			hover
		>
			<template slot="index" slot-scope="data">
				{{ paginate(data.index, payload.page, payload.limit) }}
			</template>
			<template slot="main" slot-scope="data">
				<b-badge v-if="!data.item.isParent" variant="primary">{{ $t('is_main') }}</b-badge>
				<span v-else>---</span>
			</template>
			<template slot="action" slot-scope="data">
				<div v-if="!data.item.isParent && data.item.finishDate">
					<b-link @click="toCreate('view', data.item.id)">
						<i class="fa fa-eye"/>
					</b-link>
				</div>
				<div v-else-if="!data.item.isParent && !data.item.finishDate">
					<b-link @click="toCreate('edit', data.item.id)">
						<i class="fa fa-edit"/>
					</b-link>
					<b-link @click="deleteDoc(data.item.id)">
						<i class="fa fa-trash text-danger ml-2"/>
					</b-link>
				</div>
				<b-link v-else :href="`${appUrl}/inventory`">
					<i class="fa fa-edit"/>
				</b-link>
			</template>
		</b-table>
		<nav>
			<b-pagination
				:total-rows="items.total"
				:per-page="payload.limit"
				v-model="payload.page"
				aria-controls="table"/>
		</nav>
	</b-card>
</template>

<script>
import Multiselect from 'vue-multiselect'
import InventoryService from "./inventory.service";

export default {
	name: "index",
	data() {
		return {
			payload: {
				page: 1,
				limit: 20
			},
			appUrl: process.env.VUE_APP_URL,
			items: [],
			fields: [
				{key: 'index', label: 'c', class: 'text-center'},
				{key: 'inventoryNumber', label: this.$t('prices.item.docNumber')},
				{key: 'startDate', label: this.$t('incomes.date'), class: 'text-center'},
				{key: 'departmentName', label: this.$t('incomes.department'), class: 'text-center'},
				{key: 'responsibleNames', label: this.$t('contract.responsibleName'), class: 'text-center'},
				{key: 'description', label: this.$t('incomes.reason'), class: 'text-center'},
				{key: 'main', label: this.$t('is_main'), class: 'text-center'},
				{key: 'action', label: this.$t('goods.actions'), class: 'text-center'}
			]
		}
	},
	components: {Multiselect},
	methods: {
		toCreate(action, id) {
			this.$router.push(`/warehouse-management/inventory/createOrUpdate/${action}/${id}`)
		},
		getDocList() {
			InventoryService.getDocList(this.payload).then(res => {
				this.items = res.data
			})
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		deleteDoc(docId) {
			this.$bvModal.msgBoxConfirm(this.$t('actions.deletetitle'), {
				hideHeader: true,
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'danger',
				okTitle: this.$t('actions.yes'),
				cancelTitle: this.$t('actions.no'),
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value) {
					InventoryService.deleteInventoryDoc(docId).then(res => {
						this.getDocList();
						this.$vs.notify({
							time: 1000,
							title: "Выполнена успешно!",
							color: "success",
							icon: "close",
							position: "top-right"
						});
					})
				}
			})
		}
	},
	watch: {},
	created() {
		this.getDocList();
	}
}
</script>

<style scoped>

</style>
